import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Accordion from '../../../components/common/Accordion';
import AccordionLandingHeader from '../../../components/common/Accordion/AccordionLandingHeader';
import Button from '../../../components/common/Button';
import CheckBoxField from '../../../components/common/CheckBoxField';
import TextField from '../../../components/common/TextField';
import { open } from '../../../modules/modal/actions';
import { checkMobileNumber, checkMobileNumberLive } from '../../../modules/validators';
import { registerCardAttempt, termsConsent } from '../actions';
import { getTermsConsent } from '../selectors';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { whenTheFunStops } = contentStackImageUrls;

export class CapturePhoneNumber extends Component {
  constructor() {
    super();
    this.handleMobileNumberChange = this.handleMobileNumberChange.bind(this);
    this.toggleConsent = this.toggleConsent.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOpenTerms = this.handleOpenTerms.bind(this);
    this.state = {
      mobileNumber: '',
      marketingConsent: false,
      validationErrors: [],
      submitDisabled: true
    };
  }

  componentWillReceiveProps(nextProps) {
    const { termsAccepted } = nextProps;
    const { mobileNumber } = this.state;
    const submitDisabled = checkMobileNumber(mobileNumber).length !== 0 || !termsAccepted;
    this.setState({
      submitDisabled
    });
  }

  handleMobileNumberChange(event) {
    const { termsAccepted } = this.props;
    const value = event.target.value.toString();

    const errors = checkMobileNumberLive(value);
    const submitDisabled = checkMobileNumber(value).length !== 0 || !termsAccepted;

    this.setState({
      mobileNumber: value,
      validationErrors: (errors.length) ? [errors[0]] : [],
      submitDisabled
    });
  }

  toggleConsent(name, checked) {
    if (name === 'termsConsent') {
      this.props.setTermsConsent(checked);
      return;
    }

    this.setState({
      [name]: checked
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { mobileNumber, marketingConsent } = this.state;
    const { submit, termsAccepted } = this.props;
    const errors = checkMobileNumber(mobileNumber);
    const isValid = errors.length === 0 && termsAccepted;

    this.setState({
      validationErrors: (!isValid) ? [errors[0]] : []
    });
    if (isValid) {
      const number = mobileNumber.replace(/^(44|\+44)/, '0');
      submit(number, marketingConsent);
    }
  }

  handleOpenTerms(event) {
    event.preventDefault();
    const { openModal } = this.props;
    openModal({ componentName: 'ConfirmTerms' });
  }

  render() {
    const {
      submitDisabled,
      validationErrors,
      mobileNumber,
      marketingConsent
    } = this.state;
    const { termsAccepted } = this.props;

    return (
      <div className="container--fixed-wide">
        <div className="capture-phone-number">
          <div className="container--fixed">
            <h1 className="capture-phone-number__header">Enter Mobile Number</h1>
            <p className="capture-phone-number__text">
              We require your mobile phone number in order to verify your account
            </p>
            <form onSubmit={this.handleSubmit}>
              <TextField
                name="phone"
                type="tel"
                hintText="e.g. 07788888888"
                value={mobileNumber}
                onChange={this.handleMobileNumberChange}
                className="capture-phone-number__input"
                errors={validationErrors}
                maxLength={13}
              />
              <CheckBoxField
                id="marketingConsent"
                className="capture-phone-number__checkbox-field"
                checked={!!marketingConsent}
                onChange={this.toggleConsent}
              >
                By ticking this box you agree to receive direct marketing about William Hill’s
                gambling services, free bets and other promotions. You can opt-out at any time.
              </CheckBoxField>
              <CheckBoxField
                id="termsConsent"
                className="capture-phone-number__checkbox-field"
                checked={termsAccepted}
                onChange={this.toggleConsent}
              >
                By ticking this box you are accepting William Hill {' '}
                <span className="capture-phone-number__link" onClick={this.handleOpenTerms}>
                  Terms and Conditions
                </span>.
              </CheckBoxField>
              <Button
                className="capture-phone-number__button"
                onClick={this.handleSubmit}
                disabled={submitDisabled}
              >
                Complete registration
              </Button>
            </form>
          </div>
          <p className="capture-phone-number__tip">
            You must accept the Terms and Conditions in order to continue
          </p>
          <Accordion
            header={AccordionLandingHeader}
            headerText="William Hill supports responsible gambling"
          >
            <p className="capture-phone-number__terms">
              The William Hill Plus app allows you to remotely monitor your gambling away from
              the shop which may be something you would prefer to avoid. If you are
              self-excluded from any William Hill shop or online service, have any concerns
              about your gambling, or you would like some advice around gambling
              responsibly, we would encourage you to speak to a member of the shop
              team before completing your registration.
            </p>
            <p className="capture-phone-number__terms">
              For information, help and support, visit{' '}
              <a
                className="landing-page__link"
                href="http://www.gambleaware.co.uk"
                target="_blank"
                rel="noopener noreferrer"
              >
                GambleAware
              </a>
              {' '}or call the National Gambling Helpline on Freephone{' '}
              <a
                className="landing-page__link"
                href="tel:448088020133"
              >
                0808 802 0133
              </a>
              .
            </p>
          </Accordion>

          <div className="landing-page-rg__description">
            <a
              href="http://www.whenthefunstops.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={whenTheFunStops}
                onError={(e) => { e.target.src = '../../../../assets/images/when-the-fun-stops.svg'; }}
                alt="When the fun stops"
              />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

CapturePhoneNumber.propTypes = {
  submit: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  termsAccepted: PropTypes.bool.isRequired,
  setTermsConsent: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  termsAccepted: getTermsConsent(state)
});

const mapDispatchToProps = {
  submit: registerCardAttempt,
  openModal: open,
  setTermsConsent: termsConsent
};

export default connect(mapStateToProps, mapDispatchToProps)(CapturePhoneNumber);
